var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusclesRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01443 17.4756C2.03038 18.9289 6.4527 20.0699 8.54131 17.3491C10.8004 18.4296 14.5266 18.0947 17.5603 16.4029C17.9822 16.1677 18.3813 15.8707 18.6257 15.4541C19.1775 14.5134 19.1906 13.2083 18.1839 11.2826C16.5056 7.09292 13.487 3.41527 12.2683 1.93631C12.0181 1.70814 10.4217 1.38412 9.44821 1.07276C9.01821 0.939522 8.21752 0.85119 7.25987 2.11319C6.80587 2.71149 4.74346 4.18091 7.36028 5.16906C7.76569 5.27222 8.0637 5.46245 9.91323 5.12458C10.1541 5.08278 10.7555 5.12457 11.1793 5.86843L12.0644 7.13424C12.1468 7.25207 12.2002 7.38764 12.2166 7.53048C12.3717 8.87971 12.3667 10.5689 13.1189 11.4243C11.957 10.5841 8.92063 9.58624 6.6328 12.4258M1 10.8459C2.08756 9.81163 5.23979 8.17778 8.57569 10.4693",
    stroke: "#E50067",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusclesRed);
export default __webpack_public_path__ + "static/media/musclesRed.f2c53e6b4fb33ea929fbe426c7f79511.svg";
export { ForwardRef as ReactComponent };